import {Component, OnInit, Output, EventEmitter, OnDestroy} from '@angular/core';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {select, Store} from '@ngrx/store';
import {BehaviorSubject, Observable} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {AssignToMeCommand, RemovePeopleFromTaskCommand} from '../../commands/task-manager.command';
import {CommandService} from '@core/services/command.service';
import {TaskManagerQuery} from '../../helpers/task-manager.query';
import {GetSelectedBoardAction} from '../../store/task-manager.action';
import {TaskManagerConfig} from '../../helpers/task-manager.config';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {AddMemberToItemCommand} from '../../../../commands/contacts.command';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {UserInfo} from '@shared/models/user-info.model';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {NoAccess, SupportBoardId, SupportCompanyId, TicketManager, TicketOwner} from '../../constants/task-manager.constants';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-task-assignee',
  templateUrl: './task-assignee.component.html',
  styleUrls: ['./task-assignee.component.scss']
})
export class TaskAssigneeComponent implements OnInit, OnDestroy {
  invalidateSubject: InvalidateSubject;
  dynamicData: any;
  queryKey = 'taskMembers';
  taskMembers$: Observable<any>;
  taskMembers: any;
  sourceKey: string;
  defaultPermission = {
    title: 'No Access',
    Description: '',
    permissionType: 101
  };
  api = 'TaskManagerApi';
  hasPermission = false;
  contactsMetaData: any = {};
  userInfo: UserInfo;
  currentSelectedItems: any[];
  flag: boolean;
  sendNotificationButtonDisabled: boolean;
  @Output() indirectlyMenuClickedEvent = new EventEmitter<string>();
  ngUnsubscribe = new Subject<void>();
  actionEvent$: BehaviorSubject<any> = new BehaviorSubject(null);
  private id = 'task-assignee';
  parameters: any;
  serviceName = 'TaskPeoplesDynamicItemService';
  isClient = false;

  constructor(protected shareItemService: ShareItemService,
              protected taskManagerStore: Store<TaskManagerState>,
              protected commandService: CommandService,
              private snackBarService: SnackBarService,
              protected store: Store<TaskManagerState>,
              private taskManagerApiService: TaskManagerApiService,
              private securityStore: Store<SecurityState>) {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceKey = 'TaskMemberList';
  }

  ngOnInit() {
    if (this.dynamicData.parameters?.taskApi) {
      this.api = this.dynamicData.parameters.taskApi;
    }
    this.parameters = {
      TicketId: this.dynamicData.card.id,
      Scope: this.dynamicData.card.scopeInt
    };

    this.securityStore.select(getUserInfo).subscribe(currentUser => {
      if (currentUser) {
        this.isClient = currentUser.companyId !== SupportCompanyId;
      }
    });
    // const config = Configuration.getSmartGridConfig(this.sourceKey);
    // config.Parameters.TASK_ID = this.dynamicData.card.id;
    // config.Parameters.SCOPE = this.dynamicData.card.scopeInt;
    this.securityStore.pipe(select(getUserInfo)).subscribe(state => this.userInfo = state);

    this.shareItemService.action$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(event => {
      this.handleAction(event);
    });
  }

  addNotificationsButtonClicked() {
   // this.indirectlyMenuClickedEvent.emit("TaskAlert");
    this.actionEvent$.next({id: 'TaskAlert', type: 'MainViewBodyChangeEvent', card: this.dynamicData.card});
  }
  isSupportBoard() {
    return (this.dynamicData?.board?.id === SupportBoardId);
  }
  openManageMembersDialog(showTaskManagerRole?: boolean) {
    const hasPermission = this.hasPermissions();
    if (!hasPermission) {
      this.snackBarService.showError('You don\'t have permission to access this tool');
      return;
    }
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'TaskMembersKey';
    model.itemId = this.dynamicData.card.id;
    this.taskManagerApiService.getBoardMembersByTicket(this.dynamicData.card.id, this.dynamicData.card.scopeInt, this.api)
      .pipe(take(2))
      .subscribe(res => {
        const items = res.fieldValues['TaskMembers'];
        if (items) {
          const selectedUsers = this.shareItemService.mapSelectedUserWithPermission(items.userGroups, TicketOwner, this.dynamicData.card?.board?.id);
          const maxPermission = this.dynamicData.card.permissionLevel;
          const contactsMetaData = {
            'selectedUsers': selectedUsers,
            'permissions': items.permissions.filter(p => p.permissionType >= maxPermission || p.permissionType === NoAccess),
            'defaultPermission': this.defaultPermission,
          };
          const command = new AddMemberToItemCommand('', this.dynamicData.card.id, [], model.metaData);
          if (this.isSupportBoard()) {
            command.scope = ContentScope.OrbitaxSupport;
          }
          this.shareItemService.showDialog(model, contactsMetaData, command, showTaskManagerRole, this.invalidateTaskView.bind(this), this.api);
        }
      });
  }

  invalidateTaskView(card?: any) {
    if (!card) {
      card = this.dynamicData.card;
    }
    this.dynamicData.taskInvalidator.next({card: card, sourceViewId: this.id});
  }


  assignToMe() {
    const command = new PlatformCommand('AssignToMeCommand', this.api);
    command.scope = this.dynamicData.card.scopeInt;
    command.fieldValues = {
      TaskId: this.dynamicData.card.id
    };
    this.commandService.executePlatformCommand(command).subscribe(response => {
        this.invalidateSubject.invalidate();
        this.snackBarService.showInformation('Task assignment successful');
    });
  }

  handleAction(event) {
    switch (event?.id) {
      case 'ManageMemberDialog':
        this.openManageMembersDialog();
        break;
      default:
        break;
    }
  }

  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'Edit':
          this.openManageMembersDialog();
          break;
        case 'Remove':
          this.removeShare(event.item.cells.UserModel.value);
          break;
      }
      return;
    }
  }

  removeShare(userModel: any) {
    const removePeopleFromTaskCommand = new PlatformCommand('RemoveUserFromTaskCommand', this.api);
    removePeopleFromTaskCommand.fieldValues = {
      TaskId: this.dynamicData.card.id,
      UserToRemove: userModel
    }
    removePeopleFromTaskCommand.scope = this.dynamicData.card.scopeInt;
    this.commandService.executePlatformCommand(removePeopleFromTaskCommand).subscribe(response => {
      this.invalidateTaskView(this.dynamicData.card);
      this.invalidateSubject.invalidate();
      this.store.dispatch(new GetSelectedBoardAction(TaskManagerConfig.TaskManagerApiKey,
        TaskManagerQuery.getSelectedBoard(this.dynamicData.board.id, this.dynamicData.board.scope)));
    });
  }

  sentTaskNotification() {
    const command = new PlatformCommand('SendNotificationCommand', 'TaskManagerApi');
    command.fieldValues['Ids'] = this.currentSelectedItems;
    command.fieldValues['TaskId'] = this.dynamicData.card.id;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        this.sendNotificationButtonDisabled = true;
        console.log('SendNotificationCommand ', response);
      },
      error => {
        console.error('Failed to SendNotificationCommand', error);
      });
  }

  private hasPermissions(): boolean {
    const {permissionLevel} = this.dynamicData.card;
    return (permissionLevel === TicketOwner || permissionLevel === TicketManager);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /*onSelectionChange(event: any) {
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    console.log(this.currentSelectedItems);
    if (this.currentSelectedItems.length > 0) {
      this.sendNotificationButtonDisabled = false;
    } else {
      this.sendNotificationButtonDisabled = true;
    }
  }*/
}
